import React, { Component } from "react";
import { axiosClient, config } from "../../Services/Config";
import { withRouter } from "react-router-dom";
import moment from "moment";
import BounceLoader from "react-spinners/BounceLoader";
import LoadingOverlay from "../../common/Loader";
import axios from "axios";
import Header from "../../common/header";
import Footer from "../../common/footer";
import Sidebar from "../../common/sidebar";
import { downloadExcel } from "react-export-table-to-excel";
import Toaster from "../../components/Toaster";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import AttachmentModal from "../../common/attachment";
import AssociateNotes from "../../common/associateNotes";
import { api } from "../../Services/index";
const { REACT_APP_ENV } = process.env;
var apiConfig = require("../../Services/constant.json")[REACT_APP_ENV.trim()];

import { CSVLink } from "react-csv";
// import ReactExport from "react-data-export";
import { event } from "jquery";

//pdf viewer
import AllPagesPDFViewer from "../dcg_viewer_pdf/all-pages";
import SweetAlert from "react-bootstrap-sweetalert";
import { Pagination } from "antd";
import { isEmpty } from "lodash";
// import "antd/dist/antd.css";
import getRefreshToken from "../../Services/token";
import IdleTimer from "../../common/IdleTimer";

var momentt = require("moment-timezone");
var obj = require("lodash");

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

//   const csvExportHeaders = [
//     { label: "Date", key: "date1" },
//     { label: "Total Number of Comfort Guides Created", key: "totalcomfortguide" },
//     { label: "Sketches Made", key: "totalskecthes" },
//     { label: "Comfort Guides Email", key: 'totalemail' },
//     { label: "Comfort Guides Printed", key: 'totalprint' }
//   ];

const csvExportHeaders = [
  { label: "DCG Id", key: "dcgid" },
  { label: "Associate", key: "salerepname" },
  { label: "Store", key: "naturalstoreid" },
  { label: "Customer Name", key: "customername" },
  { label: "Customer Email Id", key: "customeremail" },
  { label: "DCG Viewed On", key: "viewedon" },
];

const loaderStyle = {
  color: "#f3f3f3",
};

const pdfviewerStyle = {
  BorderTop: "2px solid black",
  display: "flex",
};

class EmailCount extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tab: 7,
      markets: [],
      stores: [],
      associates: [],
      selectedAssociate: null,
      selectedMarket: 0,
      selectedStore: [],
      selectedMarketAllStores: [],
      startDate: moment().subtract(7, "days").format("MM/DD/YYYY"),
      endDate: moment().format("MM/DD/YYYY"),
      dateLabel: "",
      emailSummaryData: [],
      emailSummaryExport: [],
      spinnerColor: "#000000",
      spinnerLoading: false,
      toasterMessage: "",
      toasterType: "",
      userLoggedIn: false,
      loginname: null,
      userloginid: null,
      pageNumber: 1,
      dcgId: "",
      firstname: "",
      lastname: "",
      phonenumber: "",
      //pdf viewer
      pdfDCGIds: [],
      samplePdfFilesList: [],
      currentPdfFileUrl:
        apiConfig.base_url + "/dcgforms/print?dcgid=1803&type=stream",
      currentPdfFileIndex: 0,
      showPdfPreview: false,
      showResultGrid: true,
      defaultPageSize: 0,
      total: 0,
      oldrequest: {},
    };
    this.changeMarket = this.changeMarket.bind(this);
    this.changeStore = this.changeStore.bind(this);
    this.changeAssociate = this.changeAssociate.bind(this);
    this.changevalue = this.changevalue.bind(this);
    this.handleCalenderEvent = this.handleCalenderEvent.bind(this);
    this.showResults = this.showResults.bind(this);
    this.reset = this.reset.bind(this);
    //pdf viewer
    this.viewPDF = this.viewPDF.bind(this);
    this.closePdfViewer = this.closePdfViewer.bind(this);
    this.onCancelPdfViewerPopup = this.onCancelPdfViewerPopup.bind(this);
  }

  componentDidMount() {
    this.defaultSearch();
  }

  defaultSearch = () =>{
    this.getMarketData();
    this.getStoreData(this.state.selectedMarket);
    this.getAssociateData(this.state.selectedMarket, 0);
    this.state.diff = moment().utcOffset(moment().format().toString())._offset;
    this.state.timezonelabel = momentt.tz(momentt.tz.guess()).zoneAbbr();
    var searchObj = {
      startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
      endDate: moment(this.state.endDate).format("YYYY-MM-DD"),
      salesrepid: this.state.selectedAssociate,
      timezone: "EST",
      storeId: [],
    };
    this.getemailSummaryData(searchObj);
    this.exportall();
  }

   clearSearch = () => {
      this.setState({
        selectedMarket: 0,
        startDate: moment().subtract(7, "days").format("MM/DD/YYYY"),
        endDate: moment().format("MM/DD/YYYY"),
        dcgId: "",
        firstname: "",
        lastname: "",
        phonenumber: "",
      }, () => {
        this.defaultSearch();
      });
    };
  clickPrintPdf = () => {
    this.hiddenNotesModal(false);
    this.openAttachmentModal(false);
    window.open(
      this.state.samplePdfFilesList[this.state.currentPdfFileIndex].fileurl,
      "PRINT",
      "height=600,width=800",
    );
  };

  clickDownloadPdf = () => {
    this.hiddenNotesModal(false);
    this.openAttachmentModal(false);
    let url = new URL(
      this.state.samplePdfFilesList[this.state.currentPdfFileIndex].fileurl,
    );
    let params = new URLSearchParams(url.search);
    params.delete("type");
    window.location.href = url.origin + "" + url.pathname + "?" + params;
  };

  // close Pdf Viewer
  closePdfViewer = () => {
    this.setState({
      showPdfPreview: false,
      showResultGrid: true,
    });
  };

  onCancelPdfViewerPopup = () => {
    this.hiddenNotesModal(false);
    this.openAttachmentModal(false);
    this.setState({
      showPdfPreview: false,
      showResultGrid: true,
    });
  };

  handleCalenderEvent(event, datepicker) {
    this.state.startDate = moment(datepicker.startDate).format("MM/DD/YYYY");
    this.state.endDate = moment(datepicker.endDate).format("MM/DD/YYYY");
    this.openAttachmentModal(false);
  }
  reset() {
    this.state.startDate = null;
    this.state.endDate = null;
    this.openAttachmentModal(false);
  }
  getMarketData() {
    try {
      this.setState({ spinnerLoading: true });
      api
        .getMarketData()
        .then((data) => {
          this.setState({
            markets: data.data,
            spinnerLoading: false,
          });
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    } catch (e) {}
  }

  getStoreData(marketId) {
    try {
      this.setState({ spinnerLoading: true });
      api
        .getStoreData(marketId)
        .then((data) => {
          this.setState({
            stores: data.data,
            spinnerLoading: false,
          });
          const arrMarketStoreIds = data.data.reduce(
            (r, c) => (
              r.storeid.push(c.storeid),
              r.marketid.push(c.marketid),
              r
            ),
            { storeid: [], marketid: [] },
          );
          this.setState({ selectedStore: arrMarketStoreIds.storeid });
          this.setState({ selectedMarketAllStores: arrMarketStoreIds.storeid });
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    } catch (e) {}
  }

  getAssociateData(marketId, storeId) {
    try {
      this.setState({ spinnerLoading: true });
      api
        .getAssociateData(marketId, storeId)
        .then((data) => {
          this.setState({
            associates: data.data,
            spinnerLoading: false,
          });
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    } catch (e) {}
  }

  changeMarket(event) {
    this.setState({ selectedMarket: event.target.value });
    this.setState({ selectedStore: [] });
    this.getStoreData(event.target.value);
    this.setState({ selectedAssociate: null });
    this.getAssociateData(event.target.value, 0);
  }

  changeStore(event) {
    var tmpStores =
      Number(event.target.value) === 0
        ? this.state.selectedMarketAllStores
        : [event.target.value];
    tmpStores.push();
    this.setState({ selectedStore: tmpStores });
    this.setState({ selectedAssociate: null });
    this.getAssociateData(this.state.selectedMarket, event.target.value);
  }

  changeAssociate(event) {
    this.setState({
      selectedAssociate: event.target.value,
    });
  }
  changevalue(e, key) {
    var obj = {};
    obj[key] = e;
    if (key == "phonenumber") {
      var text = e;
      const numbers = "0123456789";
      var numberOnly = "";
      for (let i = 0; i < 10; i++) {
        if (numbers.indexOf(text[i]) > -1) {
          numberOnly += text[i];
        }
      }
      obj[key] = numberOnly;
    }
    this.setState(obj, () => {});
  }
  tabchangeevent = (e) => {
    this.setState({ tab: e });
  };

  getemailSummaryData(searchParam) {
    try {
      this.setState({ spinnerLoading: true });
      var actionPayload = searchParam;
      this.state.oldrequest = actionPayload;
      api
        .getemailSummaryDataPost(actionPayload)
        .then((data) => {
          if (data && data.response && data.response.status == 401) {
                localStorage.removeItem("userinfo");
this.props.history.push("/login");
          } else {
            this.setState({
              emailSummaryData: data.data.data.reports
                ? data.data.data.reports
                : [],
              spinnerLoading: false,
              defaultPageSize: data.data.data.limit,
              total: data.data.data.totalCount,
            });
          }
        })
        .catch((error) => {
          console.log("Error : " + error);
          this.setState({
            spinnerLoading: false,
          });
          this.toggleToaster(
            "Failed to retrieve data from the API. Please try again later.",
            "error",
          );
        });
    } catch (e) {}
  }
  toggleToaster(message, type) {
    this.setState({
      toasterMessage: message,
      toasterType: type,
    });

    setTimeout(() => {
      this.setState({
        toasterMessage: null,
        toasterType: undefined,
      });
    }, 4000);
  }
  getrefreshtoken(actionPayload) {
    getRefreshToken()
      .then((res) => {
        api
          .getemailSummaryDataPost(actionPayload)
          .then((data) => {
            this.setState({
              emailSummaryData: data.data.data.reports
                ? data.data.data.reports
                : [],
              spinnerLoading: false,
              defaultPageSize: data.data.data.limit,
              total: data.data.data.totalCount,
            });
            this.getMarketData();
            this.getStoreData(this.state.selectedMarket);
            this.exportall();
            this.getAssociateData(this.state.selectedStore, 0);
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      })
      .catch((err) => {
         localStorage.removeItem("userinfo");
this.props.history.push("/login");
      });
  }

  exportall = () => {
    var searchObj = {};
    if (this.state.dcgId !== "") {
      searchObj["dcgid"] = this.state.dcgId;
    } else {
      searchObj["dcgid"] = null;
    }
    if (this.state.firstname !== "") {
      searchObj["firstname"] = this.state.firstname;
    } else {
      searchObj["firstname"] = null;
    }
    if (this.state.lastname !== "") {
      searchObj["lastname"] = this.state.lastname;
    } else {
      searchObj["lastname"] = null;
    }
    if (this.state.phonenumber !== "") {
      searchObj["phonenumber"] = this.state.phonenumber;
    }
    if (this.state.startDate) {
        searchObj["startDate"] = moment(this.state.startDate).format(
          "YYYY-MM-DD",
        );
      } else {
        searchObj["startDate"] = moment()
          .subtract(7, "days")
          .format("MM/DD/YYYY");
        if (this.state.dcgId == "" && this.state.firstname == "" && this.state.lastname == "" && this.state.phonenumber == "") {
          (this.state.startDate = moment()
            .subtract(7, "days")
            .format("MM/DD/YYYY"))
        }
  
      }
      if (this.state.endDate) {
        searchObj["endDate"] = moment(this.state.endDate).format("YYYY-MM-DD");
      } else {
        searchObj["endDate"] = moment().format("MM/DD/YYYY");
        if (this.state.dcgId == "" && this.state.firstname == "" && this.state.lastname == "" && this.state.phonenumber == "") {
          (this.state.endDate = moment().format("MM/DD/YYYY"))
        }
        this.openAttachmentModal(false);
      }
    if (this.state.selectedAssociate != "0") {
      searchObj["salesrepid"] = this.state.selectedAssociate;
    } else {
      searchObj["salesrepid"] = null;
    }
    if (this.state.selectedStore) {
      searchObj["storeid"] = this.state.selectedStore;
    } else {
      searchObj["storeid"] = [];
    }
    searchObj["type"] = "export";
    api
      .getemailSummaryDataPost(searchObj)
      .then((data) => {
        this.setState({
          emailSummaryExport: data.data.data.reports
            ? data.data.data.reports
            : [],
        });
      })
      .catch((error) => {
        console.log("Error : " + error);
      });
  };

  showResults = () => {
    var searchObj = {};
    if (!!this.state.firstname !== !!this.state.lastname) {
      this.state.emailSummaryData = [];
      return;
    }
    if (this.state.dcgId !== "") {
      searchObj["dcgid"] = this.state.dcgId;
    } else {
      searchObj["dcgid"] = null;
    }
    if (this.state.firstname !== "") {
      searchObj["firstname"] = this.state.firstname;
      if (this.state.lastname == "") {
        this.state.emailSummaryData = [];
      }
    } else {
      searchObj["firstname"] = null;
    }
    if (this.state.lastname !== "") {
      searchObj["lastname"] = this.state.lastname;
      if (this.state.firstname == "") {
        this.state.emailSummaryData = [];
      }
    } else {
      searchObj["lastname"] = null;
    }
    if (this.state.phonenumber !== "") {
      searchObj["phonenumber"] = this.state.phonenumber;
    }
   if (this.state.startDate) {
       searchObj["startDate"] = moment(this.state.startDate).format(
         "YYYY-MM-DD",
       );
     } else {
       searchObj["startDate"] = moment()
         .subtract(7, "days")
         .format("MM/DD/YYYY");
       if (this.state.dcgId == "" && this.state.firstname == "" && this.state.lastname == "" && this.state.phonenumber == "") {
         (this.state.startDate = moment()
           .subtract(7, "days")
           .format("MM/DD/YYYY"))
       }
 
     }
     if (this.state.endDate) {
       searchObj["endDate"] = moment(this.state.endDate).format("YYYY-MM-DD");
     } else {
       searchObj["endDate"] = moment().format("MM/DD/YYYY");
       if (this.state.dcgId == "" && this.state.firstname == "" && this.state.lastname == "" && this.state.phonenumber == "") {
         (this.state.endDate = moment().format("MM/DD/YYYY"))
       }
       this.openAttachmentModal(false);
     }
    if (this.state.selectedAssociate && this.state.selectedAssociate != "0") {
      searchObj["salesrepid"] = this.state.selectedAssociate;
    } else {
      searchObj["salesrepid"] = null;
    }
    if (this.state.selectedStore) {
      searchObj["storeid"] = this.state.selectedStore;
    } else {
      searchObj["storeid"] = [];
    }
    if (this.state.pageNumber > 1) {
      searchObj["pageNumber"] = this.state.pageNumber;
      searchObj["totalCount"] = this.state.total;
    }

    if (!("pageNumber" in searchObj)) {
      this.exportall();
    }
    this.getemailSummaryData(searchObj);
  };

  renderTableHeader() {
    var header = [];
    header =
      this.state.emailSummaryData[0] &&
      Object.keys(this.state.emailSummaryData[0]);
    return (
      <tr key="tabheader">
        <th>DCG Id</th>
        <th>Associate</th>
        <th>Store</th>
        <th>Customer Name</th>
        <th>Customer Email Id</th>
        <th>DCG Viewed On</th>
      </tr>
    );
  }

  renderTableData() {
    return (
      this.state.emailSummaryData &&
      this.state.emailSummaryData.map((data, index) => {
        const {
          dcgid,
          salerepname,
          naturalstoreid,
          customername,
          customeremail,
          viewedon,
        } = data;
        return (
          <tr>
            <td>
              {dcgid === null || dcgid === "0" ? (
                0
              ) : (
                <a
                  href="javascript:void(0);"
                  onClick={(e) => this.viewPDF(dcgid, e)}
                >
                  {dcgid}
                </a>
              )}
            </td>
            <td>{salerepname === null ? "" : salerepname}</td>
            <td>{naturalstoreid === null ? "" : naturalstoreid}</td>
            <td>{customername === null ? "" : customername}</td>
            <td>{customeremail === null ? "" : customeremail}</td>
            <td>
              {viewedon === null
                ? ""
                : viewedon &&
                  viewedon.map((v, i) => {
                    return (
                      <div class="">
                        {moment(v)
                          .tz("America/New_York")
                          .format("MM-DD-YYYY h:mm a")}
                      </div>
                    );
                  })}
            </td>
          </tr>
        );
      })
    );
  }

  formatStoreNumber = (number) => {
    return String(number).padStart(3, "0");
  };
  renderTable() {
    return (
      <div id="daily-summary-table">
        <table class="fixed table table-bordered table-striped" id="table-data">
          <thead>{this.renderTableHeader()}</thead>
          <tbody>{this.renderTableData()}</tbody>
        </table>
      </div>
    );
  }

  viewPDF = (dcgids, e) => {
    e.preventDefault();
    var arrdcgids = dcgids;
    const tmpPdfUrls = [];
    this.setState({ pdfDCGIds: arrdcgids }, () => {
      tmpPdfUrls.push({
        dcgid: this.state.pdfDCGId,
        fileurl:
          apiConfig.base_url +
          "/dcgforms/print?dcgid=" +
          this.state.pdfDCGIds +
          "&type=stream" +
          "&timezonediff=" +
          this.state.diff +
          "&timezonelabel=" +
          this.state.timezonelabel,
      });

      this.setState(
        {
          samplePdfFilesList: tmpPdfUrls,
          currentPdfFileUrl: tmpPdfUrls.fileurl,
          currentPdfFileIndex: 0,
          btnPrevPdfDisabled: true,
          btnNextPdfDisabled: tmpPdfUrls.length <= 1,
          showPdfPreview: true,
          showResultGrid: false,
        },
        () => {
          console.log("set state");
          // console.log(this.state)
        },
      );
    });
  };

  onChange = (page, pageSize) => {
    if (page) {
      this.state.pageNumber = page;
    }
    this.showResults();
    //console.log(this.state.pageNumber,page)
  };
  handleDownloadExcel = () => {
    var obj = {
      dcgid: "DCG Id",
      salerepname: "Associate",
      naturalstoreid: "Store",
      customername: "Customer Name",
      customeremail: "Customer Email",
      viewedon: "DCG Viewed On",
    };
    const header = [
      "DCG Id",
      "Associate",
      "Store",
      "Customer Name",
      "Customer Email",
      "DCG Viewed On",
    ];
    var dataInXl = [];
    this.state.emailSummaryExport.map((c, i) => {
      for (var key in obj) {
        if (!dataInXl[i]) {
          dataInXl[i] = [];
          dataInXl[i].push(c[key]);
        } else {
          if (key == "viewedon") {
            let data = "";
            if (c[key]) {
              c[key].map((v) => {
                data =
                  data +
                  " \n " +
                  moment(v).tz("America/New_York").format("MM-DD-YYYY h:mm a");
              });
            }
            dataInXl[i].push(data);
          } else {
            dataInXl[i].push(c[key]);
          }
        }
      }
    });
    downloadExcel({
      fileName: "Email_Click_Summary",
      sheet: "Email_Click_Summary",
      tablePayload: {
        header,
        // accept two different data structures
        body: dataInXl || body2,
      },
    });
  };
  hiddennotes = () => {
    this.state.activeDCGID =
      this.state.samplePdfFilesList[this.state.currentPdfFileIndex].dcgid;
    this.setState({
      showHiddenNotesModal: true,
    });
    this.openAttachmentModal(false);
  };
  openFN = async (dcgid) => {
    this.state.activeDCGID =
      this.state.samplePdfFilesList[this.state.currentPdfFileIndex].dcgid;
    this.setState({ showAttachmentModal: true });
    this.hiddenNotesModal(false);
  };
  hiddenNotesModal = (flag) => {
    this.setState({ showHiddenNotesModal: flag });
  };
  openAttachmentModal = (flag) => {
    this.setState({ showAttachmentModal: flag });
  };
  render() {
    return (
      <div className="wrapper">
        <LoadingOverlay
          active={this.state.spinnerLoading}
          spinner={<BounceLoader />}
          className={loaderStyle}
        >
          <Header />
          <Sidebar tab={this.state.tab} tabchangeevent={this.tabchangeevent} />
          <IdleTimer></IdleTimer>
          {this.state.showHiddenNotesModal && (
            <AssociateNotes
              dcgId={this.state.pdfDCGIds}
              hiddenNotesModal={this.hiddenNotesModal}
            />
          )}
          {this.state.showAttachmentModal && (
            <AttachmentModal
              dcgId={this.state.pdfDCGIds}
              openAttachmentModal={this.openAttachmentModal}
            />
          )}
          <div className="content-wrapper pb-4">
            {this.state.toasterMessage ? (
              <Toaster
                message={this.state.toasterMessage}
                toasterType={this.state.toasterType}
              />
            ) : null}
            {this.state.showResultGrid === true && (
              <section class="content">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-8">
                      <h5>Email Click Summary Report</h5>
                    </div>
                    <div class="col-md-4  alertStyle">
                      <p class="alertStyle">
                        * All the reports are displaying in EST timezone
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <hr />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>Market</label>
                        <select
                          className="form-control"
                          value={this.state.selectedMarket}
                          onChange={this.changeMarket}
                        >
                          <option value={0}>All</option>
                          {this.state.markets &&
                            this.state.markets.map((market, key) => (
                              <option value={market.marketid}>
                                {market.marketname}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>Store</label>
                        <select
                          className="form-control"
                          value={this.state.selectedStore}
                          onChange={this.changeStore}
                        >
                          <option value={0}>All</option>
                          {this.state.stores &&
                            this.state.stores.map((str, key) => (
                              <option value={str.storeid}>
                                {this.formatStoreNumber(str.naturalstoreid)}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>Associate</label>
                        <select
                          className="form-control"
                          value={this.state.selectedAssociate}
                          onChange={this.changeAssociate}
                        >
                          <option value={0}>All</option>
                          {this.state.associates &&
                            this.state.associates.map((asst, key) => (
                              <option value={asst.userloginid}>
                                {asst.loginname}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Date Range</label>
                        <div class="input-group">
                          <DateRangePicker
                            onEvent={this.handleCalenderEvent1}
                            onChange={this.handleCalenderEvent1}
                            onApply={this.handleCalenderEvent}
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                            }}
                          >
                            <input
                              type="text"
                              className="form-control"
                              value={
                                this.state.startDate && this.state.endDate
                                  ? this.state.startDate +
                                    " - " +
                                    this.state.endDate
                                  : ""
                              }
                            />
                          </DateRangePicker>
                          {this.state.startDate && this.state.endDate && (
                            <i
                              onClick={this.reset}
                              className="fa fa-times"
                              style={{ marginLeft: "5%", color: "#2470af" }}
                            ></i>
                          )}{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>DCG Id</label>
                        <div class="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="DCG Id"
                            value={this.state.dcgId}
                            onChange={(e) =>
                              this.changevalue(e.target.value, "dcgId")
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>First Name</label>
                        <div class="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="First Name"
                            value={this.state.firstname}
                            onChange={(e) =>
                              this.changevalue(e.target.value, "firstname")
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>Last Name</label>
                        <div class="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Last Name"
                            value={this.state.lastname}
                            onChange={(e) =>
                              this.changevalue(e.target.value, "lastname")
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>Phone Number</label>
                        <div class="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Phone Number"
                            pattern="[0-9]{10}"
                            value={this.state.phonenumber}
                            onChange={(e) =>
                              this.changevalue(e.target.value, "phonenumber")
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="form-group mt-1 pt-4">
                        <a
                          href="#"
                          onClick={() => {
                            ((this.state.pageNumber = 1), this.showResults());
                          }}
                          class="btn btn-primary"
                        >
                          Show
                        </a>
                        <a
                          href="#"
                          onClick={() => {
                            ((this.state.pageNumber = 1), this.clearSearch());
                          }}
                          class="btn btn-primary ml-2"
                        >
                          Clear
                        </a>
                      </div>
                     
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <hr />
                    </div>
                  </div>
                  <div class="row">
                    {!(
                      Object.entries(this.state.emailSummaryExport).length === 0
                    ) && (
                      <div class="col-md-12 text-right">
                        <label>Export : &nbsp; </label>
                        <img
                          src="dist/img/excel-icon.png"
                          className="pointer"
                          title="Export to Excel"
                          onClick={() => {
                            this.handleDownloadExcel();
                          }}
                        />
                        {/* <ExcelFile element={<a href="javascript:void(0);" class="mr-2">
                                                    <img src="dist/img/excel-icon.png" title="Export to Excel" filename="Email_Click_Summary" /></a>}>
                                                    <ExcelSheet data={this.state.emailSummaryExport} name="Email_Click_Summary">
                                                        <ExcelColumn label="DCG Id" value={(col) => (col.dcgid === null) ? "0" : col.dcgid} />
                                                        <ExcelColumn label="Associate" value={(col) => (col.salerepname === null) ? "" : col.salerepname} />
                                                        <ExcelColumn label="Store" value={(col) => (col.naturalstoreid === null) ? "" : col.naturalstoreid} />
                                                        <ExcelColumn label="Customer Name" value={(col) => (col.customername === null) ? "" : col.customername} />
                                                        <ExcelColumn label="Customer Email Id" value={(col) => (col.customeremail === null) ? "" : col.customeremail} />
                                                        <ExcelColumn label="DCG Viewed On" value={(col) => (col.viewedon === null) ? "" : (col.viewedon.map((v) => {
                                                            return (
                                                                moment(v).tz("America/New_York").format("MM-DD-YYYY h:mm a")
                                                            )
                                                        }).toString())} />
                                                    </ExcelSheet>
                                                </ExcelFile> */}

                        <CSVLink
                          headers={csvExportHeaders}
                          data={
                            this.state.emailSummaryExport &&
                            this.state.emailSummaryExport.map((row) => ({
                              ...row,
                              dcgid: row.dcgid === null ? "0" : row.dcgid,
                              salerepname:
                                row.salerepname === null ? "" : row.salerepname,
                              naturalstoreid:
                                row.naturalstoreid === null
                                  ? ""
                                  : row.naturalstoreid,
                              customername:
                                row.customername === null
                                  ? ""
                                  : row.customername,
                              customeremail:
                                row.customeremail === null
                                  ? ""
                                  : row.customeremail,
                              viewedon:
                                row.viewedon === null
                                  ? ""
                                  : row.viewedon &&
                                    row.viewedon.map((v, i) => {
                                      return moment(v)
                                        .tz("America/New_York")
                                        .format("MM-DD-YYYY h:mm a");
                                    }),
                            }))
                          }
                          filename="Email_Click_Summary.csv"
                        >
                          <img
                            src="dist/img/csv-icon.png"
                            title="Export to CSV"
                          />
                        </CSVLink>
                      </div>
                    )}
                    {!(
                      Object.entries(this.state.emailSummaryData).length === 0
                    ) && (
                      <div class="col-md-12">
                        {this.renderTable()}
                        <br></br>
                      </div>
                    )}
                    {!(
                      Object.entries(this.state.emailSummaryData).length === 0
                    ) && (
                      <div class="row">
                        <div class="col-md-12 text-right">
                          <Pagination
                            total={this.state.total}
                            showTotal={(total) => `Total ${total} items`}
                            defaultPageSize={this.state.defaultPageSize}
                            current={this.state.pageNumber}
                            onChange={this.onChange}
                            showSizeChanger={false}
                          />
                        </div>
                      </div>
                    )}
                    {Object.entries(this.state.emailSummaryData).length ===
                      0 && (
                      <div class="col-md-12">Sorry, No Records found!</div>
                    )}
                  </div>
                </div>
              </section>
            )}

            {this.state.showPdfPreview === true && (
              <div>
                <SweetAlert
                  showConfirm={false}
                  onCancel={this.onCancelPdfViewerPopup}
                  style={{
                    color: "#000000",
                    fontSize: "11px",
                    minWidth: "80%",
                    marginTop: "30px",
                    overflow: "auto",
                    overflowY: "visible",
                  }}
                  closeOnClickOutside={true}
                  allowEscape={true}
                  btnSize={"sm"}
                  customClass="containerBox"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <h5
                        style={{
                          textAlign: "right",
                          color: "#2470af",
                          cursor: "pointer",
                          fontSize: "28px",
                        }}
                        onClick={this.onCancelPdfViewerPopup}
                      >
                        {" "}
                        <i class="fas fa-times"></i>
                      </h5>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8" style={{ textAlign: "center" }}>
                      <h4>DCG Viewer</h4>
                    </div>
                    <div class="col-md-2" style={{ textAlign: "right" }}>
                      <a>
                        <img
                          src={require("../../dist/img/iconnotes.png")}
                          className="mr-3 notecolor"
                          style={{ marginBottom: 10, cursor: "pointer" }}
                          onClick={this.hiddennotes}
                          data-toggle="modal"
                          data-target="#hiddennotes"
                        />
                      </a>
                      <i
                        onClick={() => {
                          this.openFN();
                        }}
                        className="fa fa-paperclip attachment-pop"
                        style={{ cursor: "pointer" }}
                      ></i>
                      <a
                        href="javascript:void(0);"
                        class="mr-3"
                        onClick={this.clickPrintPdf}
                      >
                        <i className="fas fa-print fa-2x text-color"></i>
                      </a>
                      <a
                        href="javascript:void(0);"
                        class="mr-2"
                        onClick={this.clickDownloadPdf}
                      >
                        <i className="fas fa-download fa-2x text-color"></i>
                      </a>
                    </div>
                  </div>

                  <div class="row"></div>
                  <div class="col-md-12">
                    &nbsp;<br></br>&nbsp;
                  </div>
                  <div class="col-md-12 react-pdf__Document_p">
                    <AllPagesPDFViewer
                      pdf={
                        this.state.samplePdfFilesList[
                          this.state.currentPdfFileIndex
                        ].fileurl
                      }
                    />
                  </div>
                </SweetAlert>
              </div>
            )}
          </div>
        </LoadingOverlay>

        <Footer />
        <aside className="control-sidebar control-sidebar-dark"></aside>
      </div>
    );
  }
}
export default withRouter(EmailCount);
